import * as React from 'react';
import { Redirect, Route, withRouter } from 'react-router';
import { Layout } from 'antd';
import ScrollToTopOnMount from '../scroll_to_top_on_mount/ScrollToTopOnMount';
import SubnavTabs from '../subnav_tabs/SubnavTabs';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import { connect } from 'react-redux';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import BulkTransferSLButton from '../assets_overview_page/BulkTransferSLButton';

const { Content } = Layout;
const style = require('./StockLocationsOverviewPage.less');

class StockLocationsOverviewPage extends React.Component<any, any> {
	handleTabChange = (key) => {
		const { history } = this.props;
		history.push(`/supplier/stockLocations/overview/${key}`);
	};

	checkTabActive = (key) => {
		const { history } = this.props;
		const pathname = history.location.pathname;
		return pathname.indexOf(key) !== -1;
	};

	render() {
		const { companyConfig } = this.props;
		const tabs = [
			{
				key: 'all',
				name: 'All',
			},
		];

		return (
			<div>
				<ScrollToTopOnMount />
				<div>
					<Route
						path="/supplier/stockLocations/overview"
						exact={true}
						render={(props) => (
							<Redirect
								to={{
									pathname: '/supplier/stockLocations/overview/all',
								}}
							/>
						)}
					/>
					<Content className="stockLocationsPage" style={{ padding: '0 0.5em' }}>
						{/*<ScrollToTopOnMount/>*/}
						{/*<BackTop/>*/}

						<div
							style={{
								margin: '0 -8px',
								padding: '24px',
								paddingBottom: 0,
								background: nullSafeGet('detail.config.theme.navblock', companyConfig),
								marginBottom: 8,
							}}
						>
							<div className="flex flex-row items-center justify-between">
								<h4
									style={{
										color: 'rgba(255, 255, 255, 0.9)',
										marginRight: 8,
										marginBottom: 24,
									}}
								>
									Stock Locations
								</h4>

								<BulkTransferSLButton />
							</div>
							<SubnavTabs
								tabs={tabs}
								onChange={this.handleTabChange}
								isActive={this.checkTabActive}
							/>
						</div>
						{this.props.childRoutes.map((r, i) => (
							<RouteWithSubRoutes key={i} {...r} />
						))}
					</Content>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	companyConfig: state.company_config,
});
const mapDispatchToProps = (dispatch) => ({});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(StockLocationsOverviewPage));
